import css from './MIDIPage.module.scss';
export const Promo = () => {
  return (
    <div className={`${css.content}`}>
      <div className={css.promo}>
        <h3>Help us connect Pulsoid with VRChat words!</h3>
        <ol>
          <li>
            Share the{' '}
            <a
              href="https://blog.pulsoid.net/post/connect-your-heart-rate-to-vrchat-worlds-pulsoid-to-midi"
              target="_blank"
            >
              article
            </a>{' '}
            or a{' '}
            <a
              href="https://github.com/pulsoid-oss/pulsoid-vrchat-integration/"
              target="_blank"
            >
              GitHub link
            </a>{' '}
            with world
          </li>
          <li>
            Post about it in relevant VRChat communities (check community rules
            before posting).
          </li>
          <li>Let us know if you made a connection at support@pulsoid.net!</li>
        </ol>
        Bonus: If your connection leads to an integration within 3 months,
        you'll get a $50 reward!
      </div>
    </div>
  );
};
